import React from 'react'
import { utils_tool } from '@/tool'
let { Storage } = utils_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
import Editor from './editor'
import ResumeApply from "./apply";
const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
let componentName = 'interviewResume'
let ref_;
const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '姓名',
    name: 'searchFullName',
    dataIndex: 'searchFullName',
    searchItem: {}
  },
  {
    title: '账号',
    name: 'searchUserName',
    dataIndex: 'searchUserName',
    searchItem: {}
  },
  {
    title: '姓名',
    name: 'fullName',
    dataIndex: 'fullName',
    tableItem: {}
  },
  {
    title: '账号',
    name: 'userName',
    dataIndex: 'userName',
    tableItem: {}
  },
  {
    title: '岗位',
    name: 'positionId',
    dataIndex: 'positionId',
    searchItem: {
      ...positionConfig,
      diy: WizTableForm,
      selectType: 'radio'
    }
  },
  {
    title: '经销商名称',
    name: 'dealerName',
    dataIndex: 'dealerName',
    searchItem: {}
  },
  {
    title: '组织编码',
    name: 'dealerCode',
    dataIndex: 'dealerCode',
    searchItem: {}
  },
  {
    title: '品牌',
    name: 'orgId',
    dataIndex: 'orgId',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio'
    }
  },
  {
    title: '岗位',
    name: 'positionName',
    dataIndex: 'positionName',
    tableItem: {}
  },
  {
    title: '经销商名称',
    tableItem: {
      render: (text, record) => {
        let {dealerName, orgName} = record
        let value = orgName;
        if (dealerName!=null && dealerName!='' && dealerName!=undefined){
          value = dealerName;
        }
        return <span> { value } </span>
      }
    }
  },
  {
    title: '组织编码',
    name: 'orgCode',
    dataIndex: 'orgCode',
    tableItem: {}
  },
  {
    title: '任职状态',
    name: 'jobStateStr',
    dataIndex: 'jobStateStr',
    tableItem: {}
  },
  {
    title: '预估开业时间',
    name: 'openTimeStr',
    dataIndex: 'openTimeStr',
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'brandName',
    dataIndex: 'brandName',
    tableItem: {}
  },
  {
    title: '创建时间',
    name: 'createTime',
    dataIndex: 'createTime',
    tableItem: {}
  },
  {
    title: '申请面试',
    name: 'applyTimesStr',
    dataIndex: 'applyTimesStr',
    tableItem: {}
  },
  {
    title: '提交状态',
    name: 'submitState',
    dataIndex: 'submitState',
    dict: [
      { code: 0, codeName: '未提交' },
      { code: 1, codeName: '已提交' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      type: 'select'
    }
  },
  {
    title: '提交简历时间',
    name: 'submitTime',
    dataIndex: 'submitTime',
    tableItem: {}
  },
  {
    title: '面试状态',
    name: 'interviewState',
    dataIndex: 'interviewState',
    dict: [
      { code: 0, codeName: '待面试' },
      { code: 1, codeName: '已通过' },
      { code: 2, codeName: '未通过' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      type: 'select'
    }
  },
  {
    title: '面试简历时间',
    name: 'interviewTime',
    dataIndex: 'interviewTime',
    tableItem: {}
  }
]

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['add','export','exportResume','exportMbti'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick:{
                key: 'modal',
                params: {
                  modalParams: {
                    title: '请选择需要进行面试的学员',
                    bordered: true,
                    footer: null,
                    width: 900,
                    destroyOnClose: true,
                    diy: (e) => {
                      return <>
                        <ResumeApply
                                          changeModal={e.changeModal}
                                          ref={(r) => {
                                            ref_ = r && r.getWrappedInstance();
                                          }}
                        />
                      </>
                    },
                    onOk: () => {
                      ref_._exportExamDetailReport();
                    },
                  },
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportResume',
              custom: true,
              params: { icon: 'export', children: '导出学员简历', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'exportResume',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportMbti',
              custom: true,
              params: { icon: 'export', children: '导出性格测评报告', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'exportMbti',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['interview', 'viewResume','exportPDF'],
        rowOperateView: [
          {
            key: 'interview',
            custom: true,
            params: { children: '面试' },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'interview',
                modalParams: {
                  title: '面试结果',
                  style: { minWidth: 500 },
                  diy: (e) => {
                    let editorProps = {
                      key: 'interview_' + e.record.id,
                      ref: r => ref = r && r.getWrappedInstance(),
                      editorSuccess: () => {
                        self.doAction(apis.list)
                      },
                      ...e
                    }
                    return <Editor {...editorProps} />
                  },
                  onOk: () => {
                    ref._ok()
                  },
                  width: 400
                }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let { submitState } = record
              return { disabled: submitState !== 1 }
            }
          },
          {
            key: 'viewResume',
            custom: true,
            params: { children: '查看简历' },
            customOnClick: {},
            recordChangeParams: ({ record, rows }) => {
              let { submitState, personId,id } = record
              let tk = Storage.getStorage('token')
              return {
                disabled: submitState !== 1,
                onClick: () => {
                  window.open(`${constants.env.sys_user_url}/#/interview/resume?tk=${tk}&lookPersonId=${personId}&id=${id}`)
                }
              }
            }
          },
          {
            key: 'exportPDF',
            custom: true,
            params: { children: '生成简历' },
            recordChangeParams: ({ record, rows }) => {
              let { submitState } = record
              return { disabled: submitState !== 1 }
            },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interview/resume/export"
              }
            }
          }
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  exportResume: {
    path: `${componentName}/exportResume`,
    payload: {
      key: `${componentName}@exportResume`,
      apiParams: {}
    }
  },
  exportMbti: {
    path: `${componentName}/exportMbti`,
    payload: {
      key: `${componentName}@exportMbti`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
